export default __webpack_public_path__ + "static/media/mini.3c656017.jpg";